export enum SectionRouteNames {
    powerAndStorage = 'powerAndStorage',
    residential = 'residential',
    commercialAndIndustrial = 'commercialAndIndustrial',
    networks = 'networks',
    evs = 'evs',
    flexibility = 'flexibility',
}

export enum ResidentialResearchNames {
    smartEnergyResearch = 'smartEnergyResearch',
    heatResearch = 'heatResearch',
    solarAndBatteryResearch = 'solarAndBatteryResearch',
    evChargingResearch = 'evChargingResearch',
    residentialAll ='residentialAll'
}

export enum CommercialAndIndustrialResearchNames {
    distributedPower = 'distributedPower',
    digitalSolutions = 'candiDigitalSolutions',
    strategy = 'candiStrategy',
    solarAndBattery = 'candiSolarAndBattery',
    commercialAndIndustrialAll ='commercialAndIndustrialAll'
}

export type SectionRouteNamesResearch = keyof typeof SectionRouteNames | keyof typeof ResidentialResearchNames | keyof typeof CommercialAndIndustrialResearchNames | 'general';
